import { CreditCard, Pix } from "@mui/icons-material";
import { FaBarcode } from "react-icons/fa";
import { NegotiationPaymentMethod } from "../../../shared/services/api/sinister/SinisterNegotiationService";

// Mesmo ícone/estilo já usado em "Detalhes da taxa de setup" (TableSetup.tsx/ModalDetailSetup.tsx) —
// ícone puro, sem fundo/chip, cor só no Pix. Boleto usa o ícone de código de barras de verdade
// (react-icons/fa, já dependência do projeto) em vez de um ícone genérico do @mui/icons-material.
// Compartilhado entre TableCollectionControl e ModalCollectionInstallmentDetails pra não duplicar.
export const PAYMENT_METHOD_ICONS: Record<NegotiationPaymentMethod, JSX.Element> = {
	pix: <Pix sx={{ color: "#7bdcb5", fontSize: "medium" }} />,
	credit_card: <CreditCard fontSize="small" color="action" />,
	boleto: <FaBarcode size={16} color="#757575" />,
};

// Legenda curta ao lado do ícone (a label completa de getPaymentMethodLabel é longa demais pra caber
// numa coluna/linha compacta) — só pro usuário não precisar adivinhar pelo ícone sozinho.
export const PAYMENT_METHOD_SHORT_LABEL: Record<NegotiationPaymentMethod, string> = {
	pix: "Pix",
	credit_card: "Cartão",
	boleto: "Boleto",
};
